import { loginModal } from './Reducers/LoginModal.reducer';
import { genericLoader } from './Reducers/GenericLoader.reducer';

export const pnReducers = {
    loginModal,
    genericLoader,
};
